<template>
  <div>
    <v-data-table
      :items="participants"
      density="compact"
      hide-default-footer
      :headers="[
        {
          key: 'user',
          title: 'Учасник',
          sortable: false,
        },
        {
          key: 'agreementDate',
          title: 'Дата/Час',
        },
        {
          key: 'isAgreed',
          title: 'Статус',
        },
      ]">
      <template #item.user="{ item }">
        {{ getPersonName(item.user, { initials: true }) }}
      </template>

      <template #item.agreementDate="{ item }">
        {{ new CustomDate(item.agreementDate).toString({ time: true }) }}
      </template>

      <template #item.isAgreed="{ item }">
        <v-chip
          v-if="item.isAgreed"
          class="rounded-pill"
          density="comfortable"
          color="success">
          <v-icon icon="mdi-check" class="mr-2"></v-icon>
          <span>Погодив</span>
        </v-chip>
        <v-chip
          v-if="!item.isAgreed"
          class="rounded-pill"
          density="comfortable"
          color="black">
          <v-icon icon="mdi-progress-clock" class="mr-2"></v-icon>
          <span>Очікується</span>
        </v-chip>
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import { useDocumentAgreement } from '../../documentAgreement'
import { CustomDate, getPersonName } from 'best-modules/utils'

export default {
  name: 'DocumentAgreementUsers',
  methods: { getPersonName, CustomDate },
  setup() {
    const { participants } = useDocumentAgreement()

    return { participants }
  },
}
</script>
